import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import Switch from "@mui/material/Switch";
import React from "react";
import { AddressPrefix } from "@utils/BasicTypes";
import useDebugInformation from "../../hooks/useDebugInformation";
import { ui } from "../../interfaces/interfaces";
import { Paper } from "@mui/material";
import { useAppSelector } from "@store/hooks";

const name = "BusinessSwitchBilling"

type Props = {
  prefix: Exclude<AddressPrefix, "RelatedAddress" | "LandlordAddress">
  parent: string
}

const handleSwitchChange = (event: React.ChangeEvent<HTMLInputElement>, checked: boolean, prefix: Props["prefix"]) => ui[`${prefix}IsBusiness`] = checked;

const BusinessSwitchBilling: React.FC<Props> = ({ prefix, parent }) => {
  const isBusiness = useAppSelector(({ ui }) => ui[`${prefix}IsBusiness`])
  const asProperty = useAppSelector(({ ui }) => ui[`${prefix}AsProperty`])

  const debugName = `[${parent}]▷[${name}]`

  useDebugInformation(debugName, { prefix, parent, isBusiness, asProperty })
  return (
    <Paper elevation={1} sx={{ p: .5, borderRadius: ".5rem", position: "relative", mr: 1 }}>
      <FormGroup row sx={{ mb: 0, pb: 0 }}>
        <FormControlLabel
          control={<Switch disabled={asProperty} checked={isBusiness} onChange={React.useCallback((event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => handleSwitchChange(event, checked, prefix), [prefix])} name={`IsBusiness`} color="primary" />}
          label="Business"
          style={{ zIndex: 9999 }} sx={{ mb: 0, ml: 0 }}
        />
      </FormGroup>
    </Paper>
  );
}

export default React.memo(BusinessSwitchBilling)